import { jsx as o } from "react/jsx-runtime";
import { useCallback as a } from "react";
import { InputLabelWrapper as l } from "../input-label-wrapper/InputLabelWrapper.component.js";
import { JsonEditor as s } from "../json-input/JsonInput.component.js";
const b = ({
  id: t,
  labelText: n,
  error: p,
  containerClassName: e,
  ...r
}) => {
  const m = a(
    (i) => /* @__PURE__ */ o(s, { ...r, ...i }),
    [r]
  );
  return /* @__PURE__ */ o(
    l,
    {
      labelText: n,
      id: t,
      containerClassName: e,
      error: p,
      children: m
    }
  );
};
export {
  b as LabeledJsonInput
};
